import { Box, Container, Heading, Image, Text } from "@chakra-ui/react";
import { Element, scroller } from 'react-scroll';
import { useLocation, useHistory } from "react-router-dom";
import img_bg from "../img/img-bg.png";
import img_right from "../img/img-right.png";
import img_left from "../img/img-left.png";
import LeasingService from "../img/leasing-service.png";
import OperationsService from "../img/operations-service.png";
import BuildingBG from "../img/builing-bg.png";
import BuildingBGMob from "../img/building-bg-mob.png";
import DevelopmentService from "../img/developement-service.png";
import OwnershipService from "../img/ownership-service.png";
import React, { useState, useEffect, useRef } from "react";
import Swap from "../components/Swap";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";

const ServicePage = () => {
  const operationDivRef = React.useRef(null);
  const ownershipDivRef = React.useRef(null);
  const leasingDivRef = React.useRef(null);
  const developmentDivRef = React.useRef(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const target = searchParams.get("target") ? searchParams.get("target") : "";

  useEffect(() => {


    const hash = location.hash;
    console.log("hash", hash);

    if(hash === "#ownership"){


    setTimeout(() => {

      scroller.scrollTo('ownership', {
        duration: 500, // Animation duration in milliseconds
        smooth: true,
      });

    }, 1000);
  }

  if(hash === "#operation"){

    setTimeout(() => {

      scroller.scrollTo('operation', {
        duration: 500, // Animation duration in milliseconds
        smooth: true,
      });

    }, 1000);
    // Scroll to the targetDiv when the component mounts

  }

  if(hash === "#leasing"){

    setTimeout(() => {

      scroller.scrollTo('leasing', {
        duration: 500, // Animation duration in milliseconds
        smooth: true,
      });

    }, 1000);
    // Scroll to the targetDiv when the component mounts

  }

  if(hash === "#development"){

    setTimeout(() => {

      scroller.scrollTo('development', {
        duration: 500, // Animation duration in milliseconds
        smooth: true,
      });

    }, 1000);
    // Scroll to the targetDiv when the component mounts

  }

  }, []);

  return (
      <>
          <Helmet>
              <title>Welltower Medical Office For Lease - What We Do</title>
              <link rel="canonical" href={ absoluteUrl( "/what-we-do")} />
          </Helmet>
    <Box pt={"78px"} bgGradient="radial-gradient(36.09% 69.11% at 100% 33.15%, rgba(112, 207, 236, 0.48) 0%, rgba(116, 214, 241, 0) 100%)">
      <Container maxW={{ lg: "40%", md: "60%" }}>
        <Box textAlign={"center"} mt={12}>
          <Text fontSize={"2xl"} mb={{ base: 4, md: 0 }} color={"Teal"}>
            Our Services
          </Text>
          <Heading
            mb={12}
            fontSize={{ xl: "5xl", base: "4xl" }}
            color={"DarkTeal"}
          >
            Dedicated to you
          </Heading>
          <Text mb={6} color={"DarkBlue"}>
            When you are making the decision to move, build, or expand your
            business, you need a trusted partner that brings resources to the
            table. As one of the nation’s largest healthcare real estate
            companies, Welltower is the partner that can pull it all together
            for you.
          </Text>
          <Text pb={16} color={"DarkBlue"}>Owning healthcare real estate is who we are – and what we
            do every day is excel at Leasing, Operations, and Development. You
            and your vision are why we do what we do. Let’s begin the
            conversation.</Text>
        </Box>
      </Container>

      <Box pos={"relative"}>
        <Container
          maxW={{ lg: "90%", base: "100%" }}
          mt={{ lg: 28, md: 16, base: 8 }}
        >
          <Box
            bgImage={img_bg}
            h={{ lg: "551px", base: "100%" }}
            bgSize={"cover"}
            bgRepeat={"no-repeat"}
          >
            <Image
              w={{ lg: "auto", base: "100%" }}
              src={img_left}
              ms={{ lg: 16, base: 0 }}
              pos={"relative"}
              top={{ lg: -12, base: 0 }}
            />
            <Image
              display={{ lg: "block", base: "none" }}
              src={img_right}
              position={"absolute"}
              top={-32}
              right={0}
            />
          </Box>
        </Container>
      </Box>
      <Element name="ownership"  style={{ paddingTop: '10px' }}>
      <Box id="ownership" ref={ownershipDivRef}>
        <Swap
          points={[
            {
              id: 1,
              text: "Welltower has a distinguished history as long-term stewards of healthcare real estate. Our track record of achievement is founded on our unwavering commitment to genuine partnerships. This commitment to partnership begins with a steadfast belief in equity, where all parties unite in a collective effort to maximize value for each stakeholder.",
            },
            {
              id: 2,
              text: "We develop, own, and manage outpatient medical buildings with a long-term ownership perspective and operate them sustainably to meet the needs of the ever-evolving healthcare landscape. Using Welltower’s proprietary data insights, we identify the most convenient, desirable locations to maximize access and improve the delivery of healthcare. ",
            },
            {
              id: 3,
              text: "Welltower partners with health systems, networks, and other providers to ensure your patients have better access to in-network care, creating the best outcomes for patients.",
            },
          ]}
          title={"Ownership"}
          desc={"We are long-term owners of healthcare real estate."}
          image={OwnershipService}
        />
      </Box>
      </Element>
      <Element name="leasing"  style={{ paddingTop: '10px' }}>
      <Box id="leasing" ref={leasingDivRef}>
        <Swap
          swap={true}
          points={[
            {
              id: 1,
              text: "Let our dedicated, in-house real estate team help you locate prime healthcare space for your practice in one of our medical office facilities. Because we have national reach, the Welltower outpatient medical team employs data-driven strategic insights and local market expertise to help you find the perfect space in the right location.",
            },
            {
              id: 2,
              text: "All good relationships begin with listening. Every leasing professional seeks to understand your specific requirements first and foremost. Given our sizable portfolio, we will be able to find the right home for you and your practice.",
            },
            {
              id: 3,
              text: "Our long-term success as your leasing partner is based on our ability to work with what you need. It’s our relationships with tenants, health systems, physician groups, and healthcare real estate brokers that help to ensure your success. ",
            },
          ]}
          title={"Leasing"}
          desc={"Leverage our expertise to provide better care."}
          image={LeasingService}
        />
      </Box>
      </Element>
      <Box
        mt={48}
        h={"584px"}
        bgImage={{ md: BuildingBG, base: BuildingBGMob }}
        bgSize={{ md: "cover", base: "contain" }}
        backgroundRepeat={"no-repeat"}
      />
       <Element name="operation" style={{ paddingTop: '10px' }}>
      <Box id="operations" ref={operationDivRef}>
        <Swap
          points={[
            {
              id: 1,
              text: "The most telling indicator of our tenants’ satisfaction is our leading occupancy rate. We have one of the highest in the country in the medical office sector. As one of the nation’s largest medical office operators, we bring national best practices to each of our properties – Property Management, Asset Management, Accounting Services, and Engineering and Project Management",
            },
            {
              id: 2,
              text: "Our local, dedicated team will make sure your asset is maximized by effectively managing your space, executing building preventative maintenance, deploying cost-saving and green building initiatives, and ensuring accurate real estate tax analysis/reductions. Our In-house space planning and capital management teams raise the bar on service, giving you peace of mind to focus on what you do best – providing optimal healthcare to your patients. ",
            },
          ]}
          title={"Operations"}
          desc={"Redefining service in the Health and Wellness space."}
          image={OperationsService}
        />
      </Box>
      </Element>
      <Element name="development"  style={{ paddingTop: '10px' }}>

      <Box id="development" ref={developmentDivRef}>
        <Swap
          swap={true}
          points={[
            {
              id: 1,
              text: "Health systems and providers are facing an ever-changing healthcare delivery model.  Welltower provides data insights on each local market in the United States to help you select the optimal location.",
            },
            {
              id: 2,
              text: "A strategic partnership means that we are looking out for your needs and that we find creative and flexible ways to structure deals. And because we are an active investor in medical office buildings around the country, we bring a full spectrum of capital stack solutions.",
            },
            {
              id: 3,
              text: "Outpatient medical development is core to who we are. We are a national player in transforming the nation’s health and wellness infrastructure. Our technical expertise in these real estate assets sets us apart from generalists. Market research, site development planning, design, and construction. Join with a partner who is shaping the industry.",
            },
          ]}
          title={"Development"}
          desc={
            "Access our data insights and national expertise to realize your development vision."
          }
          image={DevelopmentService}
        />
      </Box>
      </Element>
    </Box>
      </>
  );
};

export default ServicePage;
